import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from '../Modal';
const OpenModalLink = styled.button`
  display: block;
  padding: 0;
  outline: none;
  width: 100%;
  cursor: zoom-in;
  transition: all 250ms ease;
  text-decoration: none;
    border: none;
  &:hover {
    transform: scale(1.02);
    filter: brightness(0.8);
  }

`
const ClickThroughModalWrapper = ({
  modalContent,
  anchorProps,
  heading,
  children,
}) => {
  const [showImg, setShowImg] = useState(false);
  const showModal = () => {
    setShowImg(true);
  };
  const hideModal = () => {
    setShowImg(false);
  };
  const ModalContent = modalContent
  return modalContent ? (
    <>
      <OpenModalLink title="See preview" onClick={showModal} {...anchorProps}>
        {children}
      </OpenModalLink>
      <Modal isVisible={showImg} onRequestClose={hideModal} heading={heading}>
        {ModalContent}
      </Modal>
    </>
  ) : (
    children
  );
};

export default ClickThroughModalWrapper;
